import React, { useState } from "react";
import { BulbOutlined, DownOutlined } from "@ant-design/icons";
import { CompanyCardData } from "./types";

interface Props {
  steps: CompanyCardData["reasoning_steps"];
  defaultOpen?: boolean;
}

const ModelReasoning: React.FC<Props> = ({ steps, defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="vi-glass-card overflow-hidden mb-[18px]">
      {/* Summary / toggle */}
      <div className="w-full flex items-center gap-3 px-6 py-5">
        <button
          onClick={() => setOpen((o) => !o)}
          className="flex items-center gap-3 flex-1 min-w-0 cursor-pointer bg-transparent border-0 text-left p-0"
        >
          <div className="w-[38px] h-[38px] rounded-[11px] bg-primary/10 text-primary flex items-center justify-center text-xl flex-shrink-0">
            <BulbOutlined />
          </div>

          <h3 className="font-dm text-[19px] font-semibold text-neutral m-0 flex-1 min-w-0">
            Why our model flags this company
          </h3>
        </button>

        <span className="text-[11px] bg-primary/10 text-primary px-2.5 py-1 rounded-full font-semibold font-dm flex-shrink-0">
          Idea, not advice
        </span>


        <button
          onClick={() => setOpen((o) => !o)}
          className="bg-transparent border-0 p-0 cursor-pointer flex-shrink-0"
          aria-label={open ? "Collapse" : "Expand"}
        >
          <DownOutlined
            className={`text-grey text-[18px] transition-transform duration-200 ${
              open ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>

      {/* Steps */}
      {open && (
        <div className="px-6 pb-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className="flex gap-3.5 py-3 border-t border-grey first:border-t-0"
            >
              <div className="w-[26px] h-[26px] rounded-full bg-primary text-white text-[13px] font-semibold flex items-center justify-center flex-shrink-0 mt-0.5">
                {i + 1}
              </div>
              <div>
                <p className="font-semibold text-[14.5px] text-neutral font-dm m-0 mb-0.5">
                  {step.title}
                </p>
                <p
                  className="text-[13.5px] text-neutral/70 font-dm m-0 [&_b]:text-primary [&_b]:font-semibold"
                  dangerouslySetInnerHTML={{ __html: step.detail }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ModelReasoning;
